import { ToggleSwitch } from "@risalabs_frontend_org/oasis-ui-kit";
import { Button, openModal, TextInput } from "risa-oasis-ui_v2";
import { ADD_FAMILY_MODAL_ID } from "./AddFamilyModal";

/**
 * Props for the biosimilar config page header toolbar.
 */
interface BiosimilarConfigHeaderProps {
  /** Current filter query. */
  filterQuery: string;
  /** Updates the family filter query. */
  onFilterChange: (value: string) => void;
  /** Number of families after filtering. */
  filteredCount: number;
  /** Total families in the document. */
  totalCount: number;
  /** Whether biosimilar initiation is enabled. */
  enabled: boolean;
  /** Toggles the enabled flag. */
  onEnabledChange: (enabled: boolean) => void;
  /** Whether a save is in progress. */
  saving: boolean;
}

/**
 * Header row with filter, enabled toggle, and add-family action.
 *
 * @param props - Header state and handlers
 * @returns Toolbar matching the drug family configuration design
 */
const BiosimilarConfigHeader = ({
  filterQuery,
  onFilterChange,
  filteredCount,
  totalCount,
  enabled,
  onEnabledChange,
  saving,
}: BiosimilarConfigHeaderProps) => (
  <div className="flex flex-col gap-4 border-b border-primaryGray-16 pb-4">
    <div className="flex flex-row items-start justify-between gap-4">
      <div>
        <div className="text-h11 font-bold text-primaryGray-1">
          Drug Family Configuration
        </div>
        <div className="mt-1 text-small text-primaryGray-4">
          Manage drug family substitution rules and dose conversions.
        </div>
      </div>
      <div className="flex flex-row items-center gap-3">
        <div className="flex flex-row items-center gap-2">
          <span
            className={`text-small font-semibold ${
              enabled ? "text-[#005D49]" : "text-primaryGray-7"
            }`}
          >
            Enabled
          </span>
          <ToggleSwitch
            key={`biosimilar-config-enabled-${enabled}`}
            id="biosimilar-config-enabled"
            defaultChecked={enabled}
            onChangeEmit={() => onEnabledChange(!enabled)}
          />
        </div>
        <Button
          buttonType="primary"
          size="medium"
          onClick={() => openModal(ADD_FAMILY_MODAL_ID)}
          disabled={saving}
          children="Add Family"
        />
      </div>
    </div>

    <div className="flex flex-row items-end gap-3">
      <div className="flex-1">
        <TextInput
          id="biosimilar-family-filter"
          label="Filter families"
          placeholder="Filter families..."
          defaultValue={filterQuery}
          onChange={(event) => onFilterChange(event.value)}
        />
      </div>
      <div className="rounded border border-primaryGray-16 px-3 py-2 text-small text-primaryGray-4">
        {filteredCount} of {totalCount} families
      </div>
    </div>
  </div>
);

export default BiosimilarConfigHeader;
